import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR from 'swr';
import appContext from '../../../context/app/appContext';

const usePendingAmounts = () => {
    const { account } = useWeb3React();

    const { sdk } = useContext(appContext);

    const { data, error } = useSWR(
        sdk && account ? ['pendingAmounts', account] : null,
        (_, userAddress) => sdk!.spools.getPendingAmounts(userAddress!)
    );

    return {
        pendingAmounts: data,
        isLoading: !error && !data,
        error,
    };
};

export default usePendingAmounts;
